import {Component} from '@angular/core';
import {OrdersSuccessData} from "../../../../interfaces/orders-success-data";

@Component({
  selector: 'app-message-delivery-confirm',
  templateUrl: './message-delivery-confirm.component.html',
  styleUrls: ['./message-delivery-confirm.component.scss']
})
export class MessageDeliveryConfirmComponent {
  public data: OrdersSuccessData;
  public user;
  public isDeliveryConfirmation: boolean = false;

  deliveryConfirmationShow(data: OrdersSuccessData, user) {
    this.data = data;
    this.user = user;
    this.isDeliveryConfirmation = true;
  }

    protected readonly parseFloat = parseFloat;
}
